// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
		ion-item-divider {
			min-height: 0px;
		}
	`, "",{"version":3,"sources":["webpack://./src/app/components/shared/vehicle-list-item/vehicle-list-item.popover.ts"],"names":[],"mappings":";EACE;GACC,eAAe;EAChB","sourcesContent":["\n\t\tion-item-divider {\n\t\t\tmin-height: 0px;\n\t\t}\n\t"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
